module.exports = __webpack_public_path__ + "img/motor_no71.dd5bd5ce.jpg";